import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { useDebounce } from 'use-debounce';
import { formatValue, parseValue } from '../format/valueFormatters';
import { defineStyles } from '../theme';
const PROPAGATION_DEBOUNCE_MS = 350;
const styles = defineStyles({
    selectInput: {
        minWidth: 150,
    },
});
function propagateValue(localValue, columnFormat, operator, onChange) {
    const parsed = parseValue(localValue, columnFormat, operator);
    onChange(parsed ?? '');
}
export function FormattedConditionValueInput({ field, columnFormat, operator, label, fullWidth, }) {
    const [isFocused, setIsFocused] = useState(false);
    const [localValue, setLocalValue] = useState('');
    const [debouncedLocalValue] = useDebounce(localValue, PROPAGATION_DEBOUNCE_MS);
    const displayValue = isFocused ? localValue : formatValue(field.value, columnFormat);
    useEffect(() => {
        if (isFocused && columnFormat && operator) {
            propagateValue(debouncedLocalValue, columnFormat, operator, field.onChange);
        }
    }, [debouncedLocalValue, isFocused, columnFormat, operator, field.onChange]);
    return (_jsx(TextField, { label: label, fullWidth: fullWidth, InputLabelProps: label ? { shrink: true } : undefined, value: displayValue, onFocus: () => {
            setIsFocused(true);
            setLocalValue(formatValue(field.value, columnFormat) ?? '');
        }, onChange: (e) => setLocalValue(e.target.value), onBlur: () => {
            propagateValue(localValue, columnFormat, operator, field.onChange);
            field.onBlur();
            setIsFocused(false);
        }, variant: "outlined", size: "small", sx: styles.selectInput, onPaste: (e) => {
            e.preventDefault();
            setLocalValue(e.clipboardData.getData('text/plain').trim());
        } }));
}
//# sourceMappingURL=FormattedConditionValueInput.js.map